module.exports = __webpack_public_path__ + "img/pc2.2df9f1bc.png";